import { RECEIVER_STATUSES } from '../../constants/custom-store-shipouts.constants';
export function isReceiverWithErrors(receiver) {
  return [RECEIVER_STATUSES.SHIPMENT_CALCULATION_ERROR, RECEIVER_STATUSES.SHIPMENT_LOCATION_ERROR].includes(receiver.status);
}